<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>Cadastro de Usuários</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:200px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs12 sm5>
                    <v-text-field v-model="usuario.nome" label="Nome" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                      @click:append="showP = !showP"
                      v-model="usuario.senha"
                      :rules="senhaRules"
                      label="Senha"
                      required
                      :type="showP ? 'text' : 'password'"
                      :append-icon="showP ? 'visibility_off' : 'visibility'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-switch
                      label="Ativo"
                      v-model="usuario.ativo"
                      false-value="N"
                      true-value="S"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small  color="primary" @click="$router.push('/usuarios')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="salvar()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showFlash, showError } from '@/utils'
import usuarioService from '@/services/usuario'

export default {
  name: 'usuarios',
  data () {
    return {
      search: '',
      usuario: {},
      itemList: [],
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      showP: false,
      modo: '',
      resultado: {},
      senhaRules: [v => !!v || 'Campo obrigatório'],
      itemSenha: [
        'N',
        'S'
      ]
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      if (id === undefined) {
        this.usuario.id = ''
        this.usuario.ativo = 'S'
        this.modo = 'I'
        return
      }
      this.modo = 'A'
      this.usuario = await usuarioService.getById(id)
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    isAlterar: function () {
      return this.modo === 'A'
    }
  },
  methods: {
    async salvar () {
      if (this.usuario.nome === undefined) {
        showError('Usuário inválido')
        return
      }
      if (this.usuario.senha === undefined) {
        showError('Senha inválida')
        return
      }
      try {
        this.loading = true
        if (this.modo === 'A') {
          this.resultado = await usuarioService.savePut(this.usuario)
        } else {
          this.resultado = await usuarioService.savePost(this.usuario)
        }
        if (this.modo === 'I') { // NOVA EMPRESA
          if (this.resultado === undefined) {
            this.usuarios = this.resultado
            showFlash('Usuário já existe')
          } else {
            showFlash('Usuário já existe')
          }
        } else { // ASSOCIADO EXISTENTE
        }
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
